import cx from 'classnames';
import { PropsWithChildren } from 'react';

import styles from './BottomSheetHeader.module.css';

import { useBottomSheetContext } from '../BottomSheetContext';
import CloseButton from './BottomSheetCloseButton';
import Box, { BoxStyleProps } from '../../Box';

interface BottomSheetHeaderProps extends BoxStyleProps {
  className?: string;
}

export default function BottomSheetHeader({
  className,
  children,
  ...otherProps
}: PropsWithChildren<BottomSheetHeaderProps>): JSX.Element {
  const { close } = useBottomSheetContext();

  return (
    <Box className={cx(styles['base'], className)} {...otherProps}>
      <div className={styles['content']}>{children}</div>
      <CloseButton onClick={close} dataTestId="bottom-sheet-close-button" />
    </Box>
  );
}
